import {
  FormControlLabel,
  Radio,
  RadioGroup,
  FormControl,
} from "@material-ui/core";
import Slider from "@material-ui/core/Slider";
import React, { Component } from "react";
// import "react-responsive-modal/styles.css";
import { Image, Container, Modal, Button, Row, Col } from "react-bootstrap";
import { Toggle } from "../../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import RatingsFilter from "./RatingFilter";
import PriceFilter from "./PriceFilter";

export class Fillter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      not_confirmed: false,
      confirmed_user: false,
      seating_status: "",
      errors: {},
      dispType: 6,
    };
  }
  changeDisplay = async (type) => {
    await this.setState({ dispType: type });
  };
  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  resetFilter = (e) => {
    this.setState({
      not_confirmed: false,
      confirmed_user: false,
    });
  };

  /***************************
   * @DESC Big Button Handler
   ***************************/
  bigButtonHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      seating_status: type,
    });
  };

  /******************************
   * @DESC - ON SUBMIT HANDLER
   *****************************/
  onSubmitHandler = (e) => {
    e.preventDefault();
    const formData = {
      seating_status: this.state.seating_status,
    };
    console.log(formData);
  };

  render() {
    const { open, dispType } = this.state;
    return (
      <React.Fragment>
        <div
          onClick={this.onOpenModal}
          // className="d-flex align-items-center justify-content-between cursor "
        >
          <Image
            alt="filter"
            title="filter"
            width="60px"
            src={require("../../../../assets/images/seatingImages/filter.svg")}
            className="img-fluid"
            // src={require("../../../../assets/images/ActionImages/image/filter.svg")}
          />
          {/* <div className="f12-500 text-blue mx-2">Filter</div>
          <i className="fa fa-angle-down text-blue" aria-hidden="true"></i> */}
        </div>
        <Modal show={open} size="lg" onHide={this.onCloseModal} centered>
          <Modal.Header className="border-0" closeButton>
            <Modal.Title className="f24_700_HelveticaNeue">
              Sort & Filter
            </Modal.Title>
          </Modal.Header>
          <hr />
          <Modal.Body>
            <Container
              fluid
              className="vendor-orders-request"
              style={{ padding: 0 }}
            >
              <Row>
                <Col sm={5}>
                  <div className={`w-100 div-model-filter-left`}>
                    <div
                      className={`w-100 ${
                        dispType === 1 && "div-model-active-filter-left"
                      }`}
                      onClick={() => {
                        this.changeDisplay(1);
                      }}
                    >
                      Sort By
                      <br />
                      <span style={{ color: "#EE3A23", fontSize: ".75rem" }}>
                        Relevance
                      </span>
                    </div>
                    <div
                      className={`w-100 ${
                        dispType === 2 && "div-model-active-filter-left"
                      }`}
                      onClick={() => {
                        this.changeDisplay(2);
                      }}
                    >
                      Food Type
                    </div>
                    <div
                      className={`w-100 ${
                        dispType === 3 && "div-model-active-filter-left"
                      }`}
                      onClick={() => {
                        this.changeDisplay(3);
                      }}
                    >
                      Cuisine
                    </div>
                    <div
                      className={`w-100 ${
                        dispType === 4 && "div-model-active-filter-left"
                      }`}
                      onClick={() => {
                        this.changeDisplay(4);
                      }}
                    >
                      Allergy / Nutrition Info
                    </div>
                    <div
                      className={`w-100 ${
                        dispType === 5 && "div-model-active-filter-left"
                      }`}
                      onClick={() => {
                        this.changeDisplay(5);
                      }}
                    >
                      Ratings
                    </div>
                    <div
                      className={`w-100 ${
                        dispType === 6 && "div-model-active-filter-left"
                      }`}
                      onClick={() => {
                        this.changeDisplay(6);
                      }}
                    >
                      Price
                    </div>
                    <div
                      className={`w-100 ${
                        dispType === 7 && "div-model-active-filter-left"
                      }`}
                      onClick={() => {
                        this.changeDisplay(7);
                      }}
                    >
                      Personalization
                    </div>
                  </div>
                </Col>
                <Col sm={7} style={{ padding: 0 }}>
                  {dispType === 1 && <SortByFilter />}
                  {dispType === 2 && <FoodTypeFilter />}
                  {dispType === 3 && <CuisineFilter />}
                  {dispType === 4 && <AllergyNutritionInfoFilter />}
                  {dispType === 5 && <RatingsFilter />}
                  {dispType === 6 && <PriceFilter />}
                  {dispType === 7 && <PersonalizationFilter />}
                  <Container
                    style={{
                      bottom: 0,
                      position: "absolute",
                    }}
                  >
                    <hr />
                    <div className=" d-flex align-items-center">
                      <Button
                        variant="danger"
                        className="btn-md px-5 w-100"
                        onClick={this.onCloseModal}
                      >
                        Apply Filter
                      </Button>
                    </div>
                  </Container>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}

const PersonalizationFilter = (props) => {
  return (
    <React.Fragment>
      <Container fluid>
        <h4>Personalization</h4>
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td style={{ width: "25px" }}>
                <input type="checkbox" />
              </td>
              <td>
                <b>Salt Level</b>
                <br />
                <span style={{ fontSize: ".8rem" }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit
                </span>
              </td>
            </tr>
            <tr>
              <td style={{ width: "25px" }}>
                <input type="checkbox" />
              </td>
              <td>
                <b>Sugar Level</b>
                <br />
                <span style={{ fontSize: ".8rem" }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit
                </span>
              </td>
            </tr>
            <tr>
              <td style={{ width: "25px" }}>
                <input type="checkbox" />
              </td>
              <td>
                <b>Spice Level</b>
                <br />
                <span style={{ fontSize: ".8rem" }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit
                </span>
              </td>
            </tr>
            <tr>
              <td style={{ width: "25px" }}>
                <input type="checkbox" />
              </td>
              <td>
                <b>Fat/Oil/Fried Level</b>
                <br />
                <span style={{ fontSize: ".8rem" }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit
                </span>
              </td>
            </tr>
            <tr>
              <td style={{ width: "25px" }}>
                <input type="checkbox" />
              </td>
              <td>
                <b>Meat Cook</b>
                <br />
                <span style={{ fontSize: ".8rem" }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit
                </span>
              </td>
            </tr>
            <tr>
              <td style={{ width: "25px" }}>
                <input type="checkbox" />
              </td>
              <td>
                <b>Egg Cook</b>
                <br />
                <span style={{ fontSize: ".8rem" }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </Container>
    </React.Fragment>
  );
};

const ratings = [
  {
    value: 0,
    label: 0,
  },
  {
    value: 1,
    label: 1,
  },
  {
    value: 2,
    label: 2,
  },
  {
    value: 3,
    label: 3,
  },
  {
    value: 4,
    label: 4,
  },
  {
    value: 5,
    label: 5,
  },
];

const AllergyNutritionInfoFilter = (props) => {
  return (
    <React.Fragment>
      <Container fluid>
        <Row>
          <Col sm={8}>
            <div>
              <h4>Allergy Info</h4>
              <p style={{ fontSize: ".8rem" }}>
                Show dishes which have allergy info
              </p>
            </div>
          </Col>
          <Col sm={4}>
            <Toggle
              checked={false}
              // toggleFunction={toggleFunction}
            />
          </Col>
        </Row>
        <hr />
        <Row>
          <Col sm={8}>
            <div>
              <h4>Nutrition Info</h4>
              <p style={{ fontSize: ".8rem" }}>
                Show dishes which have nutrition info only
              </p>
            </div>
          </Col>
          <Col sm={4}>
            <Toggle
              checked={true}
              // toggleFunction={toggleFunction}
            />
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

const CuisineFilter = (props) => {
  return (
    <React.Fragment>
      <Container fliud>
        <div>
          <h4>Cuisine</h4>
          <br />
          <div class="form-group has-feedback has-feedback-left">
            <input type="text" class="form-control" placeholder="Search" />
            <i class="glyphicon glyphicon-user form-control-feedback"></i>
          </div>
          <br />
          <input type="checkbox" name="foodtype" value="Afghani" />
          &nbsp;Afghani
          <br />
          <input type="checkbox" name="foodtype" value="African" />
          &nbsp;African
          <br />
          <input type="checkbox" name="foodtype" value="Eggs" />
          &nbsp;American
          <br />
          <input type="checkbox" name="foodtype" value="Andhra" />
          &nbsp;Andhra
          <br />
          <input type="checkbox" name="foodtype" value="Arabian" />
          &nbsp;Arabian
          <br />
          <input type="checkbox" name="foodtype" value="Asian" />
          &nbsp;Asian
          <br />
        </div>
      </Container>
    </React.Fragment>
  );
};

const FoodTypeFilter = (props) => {
  return (
    <React.Fragment>
      <Container fliud>
        <div>
          <h4>Food Type</h4>
          <br />
          <div class="form-group has-feedback has-feedback-left">
            <input type="text" class="form-control" placeholder="Search" />
            <i class="glyphicon glyphicon-user form-control-feedback"></i>
          </div>
          <br />
          <input type="checkbox" name="foodtype" value="Crustacean" />
          &nbsp;Crustacean
          <br />
          <input type="checkbox" name="foodtype" value="Dairy Free" />
          &nbsp;Dairy Free
          <br />
          <input type="checkbox" name="foodtype" value="Eggs" />
          &nbsp;Eggs
          <br />
          <input type="checkbox" name="foodtype" value="Fruitarian" />
          &nbsp;Fruitarian
          <br />
          <input type="checkbox" name="foodtype" value="Halal" />
          &nbsp;Halal
          <br />
          <input type="checkbox" name="foodtype" value="Kosher" />
          &nbsp;Kosher
          <br />
          <input type="checkbox" name="foodtype" value="Vegan" />
          &nbsp;Vegan
          <br />
          <input type="checkbox" name="foodtype" value="Organic" />
          &nbsp;Organic
          <br />
          <input type="checkbox" name="foodtype" value="Bakery" />
          &nbsp;Bakery
          <br />
        </div>
      </Container>
    </React.Fragment>
  );
};

const SortByFilter = (props) => {
  return (
    <React.Fragment>
      <div className="container-fluid">
        <h4>Sort By</h4>
        <br />
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="Sort By"
            name="Sort By"
            // value={value}
            // onChange={handleChange}
          >
            <FormControlLabel
              value="Relevance"
              control={<Radio />}
              label="Relevance"
            />
            <FormControlLabel
              value="Preparation Time"
              control={<Radio />}
              label="Preparation Time"
            />
            <FormControlLabel
              value="Ratings"
              control={<Radio />}
              label="Ratings"
            />
            <FormControlLabel
              value="Cost for Two"
              control={<Radio />}
              label="Cost for Two"
            />
            <FormControlLabel
              value="Has Offers"
              control={<Radio />}
              label="Has Offers"
            />
            <FormControlLabel
              value="Spice Level"
              control={<Radio />}
              label="Spice Level"
            />
          </RadioGroup>
        </FormControl>
      </div>
    </React.Fragment>
  );
};

export default Fillter;
